import * as i0 from '@angular/core';
import { input, computed, signal, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["*", [["", "badge-icon", ""]]];
const _c1 = ["*", "[badge-icon]"];
const _c2 = (a0, a1, a2) => [a0, a1, a2];
function NgxBadgeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("ngx-badge-icon ngx-badge-icon-" + ctx_r0.size());
  }
}
function NgxBadgeComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
let NgxBadgeComponent = /*#__PURE__*/(() => {
  class NgxBadgeComponent {
    constructor() {
      this.size = input('md');
      this.status = input('info');
      this.mode = input('bold');
      this.type = input('text');
      this.template = input();
      this.circularIcon = input(false);
      this.circularBorderColor = input('#fff');
      this.hasIcon = input(false);
      this.iconDirection = input('right');
      this.classList = input('');
      this.badgeStyle = computed(() => {
        if (this.circularIcon()) {
          return {
            borderColor: this.circularBorderColor()
          };
        } else {
          return {
            border: 'none'
          };
        }
      });
      this.classes = computed(() => {
        const classArr = ['ngx-badge', `ngx-badge-${this.size()}`, `icon-${this.iconDirection()}`];
        if (this.type() === 'count') {
          classArr.push('ngx-badge-count');
        }
        if (this.type() === 'icon') {
          classArr.push('ngx-badge-type-icon');
        }
        if (this.circularIcon()) {
          classArr.push('ngx-badge-circular-icon border-300');
        }
        return classArr.join(' ');
      });
      this.colorClasses = computed(() => this.makeClassColor());
      this.badgeColors = signal({
        bold: {
          backgroundColor: {
            info: 'surface-brand',
            error: 'surface-error',
            success: 'surface-success',
            warning: 'surface-status-warning',
            inactive: 'onback-shade-90',
            neutral: 'steel-shade-30'
          },
          textColor: {
            info: 'text-oninvert-high',
            error: 'text-oninvert-high',
            success: 'text-oninvert-high',
            warning: 'text-onback-high',
            inactive: 'text-onback-disabled',
            neutral: 'text-oninvert-high'
          }
        },
        fill: {
          backgroundColor: {
            info: 'surface-brand-tint',
            error: 'surface-error-tint',
            success: 'surface-success-tint',
            warning: 'surface-warning-tint',
            neutral: 'steel-shade-95'
          },
          textColor: {
            info: 'text-onback-brand',
            error: 'text-onback-error',
            success: 'text-onback-success',
            warning: 'text-onback-warning',
            neutral: 'text-onback-high'
          }
        },
        outline: {
          backgroundColor: {
            info: 'border-color-brand',
            error: 'border-color-error',
            success: 'border-color-success',
            warning: 'border-color-warning',
            inactive: 'border-color-disabled',
            neutral: 'border-color-tint'
          },
          textColor: {
            info: 'text-onback-brand',
            error: 'text-onback-error',
            success: 'text-onback-success',
            warning: 'text-onback-warning',
            inactive: 'text-onback-disabled',
            neutral: 'text-onback-medium'
          }
        }
      });
    }
    makeClassColor() {
      const classArr = [];
      const colors = this.badgeColors()[this.mode()];
      classArr.push(colors.backgroundColor[this.status()]);
      classArr.push(colors.textColor[this.status()]);
      if (this.mode() === 'outline') {
        classArr.push('border-300');
      }
      return classArr.join(' ');
    }
    static {
      this.ɵfac = function NgxBadgeComponent_Factory(t) {
        return new (t || NgxBadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxBadgeComponent,
        selectors: [["ngx-badge"]],
        inputs: {
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          status: [i0.ɵɵInputFlags.SignalBased, "status"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          template: [i0.ɵɵInputFlags.SignalBased, "template"],
          circularIcon: [i0.ɵɵInputFlags.SignalBased, "circularIcon"],
          circularBorderColor: [i0.ɵɵInputFlags.SignalBased, "circularBorderColor"],
          hasIcon: [i0.ɵɵInputFlags.SignalBased, "hasIcon"],
          iconDirection: [i0.ɵɵInputFlags.SignalBased, "iconDirection"],
          classList: [i0.ɵɵInputFlags.SignalBased, "classList"]
        },
        ngContentSelectors: _c1,
        decls: 4,
        vars: 8,
        consts: [[3, "ngClass", "ngStyle"], [3, "class"], [4, "ngTemplateOutlet"]],
        template: function NgxBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxBadgeComponent_Conditional_1_Template, 2, 2, "span", 1)(2, NgxBadgeComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c2, ctx.classes(), ctx.colorClasses(), ctx.classList()))("ngStyle", ctx.badgeStyle());
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.hasIcon() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template());
          }
        },
        dependencies: [i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.ngx-badge[_ngcontent-%COMP%]{direction:rtl;display:flex;align-items:center;justify-content:center;border-radius:48px;width:fit-content;gap:4px;overflow:hidden}.ngx-badge.icon-left[_ngcontent-%COMP%]{flex-direction:row-reverse}.ngx-badge-lg[_ngcontent-%COMP%]{height:40px;padding:0 8px;font-size:14px;line-height:24px}.ngx-badge-lg.ngx-badge-count[_ngcontent-%COMP%]{min-width:13px}.ngx-badge-lg.ngx-badge-type-icon[_ngcontent-%COMP%]{width:20px;height:20px;padding:0}.ngx-badge-md[_ngcontent-%COMP%]{height:28px;padding:0 8px;font-size:12px;line-height:20px}.ngx-badge-md.ngx-badge-count[_ngcontent-%COMP%]{min-width:9px}.ngx-badge-md.ngx-badge-type-icon[_ngcontent-%COMP%]{width:18px;height:18px;padding:0}.ngx-badge-sm[_ngcontent-%COMP%]{height:24px;padding:0 6px;font-size:10px;line-height:16px}.ngx-badge-sm.ngx-badge-count[_ngcontent-%COMP%]{min-width:5px}.ngx-badge-sm.ngx-badge-type-icon[_ngcontent-%COMP%]{width:16px;height:16px;padding:0}.ngx-badge-icon[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.ngx-badge-icon-lg[_ngcontent-%COMP%]     img{width:20px;height:20px}.ngx-badge-icon-md[_ngcontent-%COMP%]     img, .ngx-badge-icon-sm[_ngcontent-%COMP%]     img{width:16px;height:16px}.ngx-badge-circular-icon[_ngcontent-%COMP%]     span :first-child{z-index:1}.ngx-badge-count[_ngcontent-%COMP%]{padding:0 5.5px;font-feature-settings:var(--base-font-feature-settings),\"ss07\" on!important}.ngx-badge-count.ngx-badge-lg[_ngcontent-%COMP%]{height:24px}.ngx-badge-count.ngx-badge-md[_ngcontent-%COMP%]{height:20px}.ngx-badge-count.ngx-badge-sm[_ngcontent-%COMP%]{height:16px}.ngx-badge-count.ngx-badge-tiny[_ngcontent-%COMP%]{height:12px}.ngx-badge-tiny[_ngcontent-%COMP%]{font-size:8px;line-height:12px;padding:4px 6px}.ngx-badge-btnBadge[_ngcontent-%COMP%]{font-size:8px;line-height:12px;padding:2px 4px}.onback-shade-90[_ngcontent-%COMP%]{background:var(--onback-shade-90)}.steel-shade-30[_ngcontent-%COMP%]{background-color:#4f5562}.steel-shade-95[_ngcontent-%COMP%]{background-color:#eaeff7}.surface-status-warning[_ngcontent-%COMP%]{background-color:#fec003}"]
      });
    }
  }
  return NgxBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBadgeModule = /*#__PURE__*/(() => {
  class NgxBadgeModule {
    static {
      this.ɵfac = function NgxBadgeModule_Factory(t) {
        return new (t || NgxBadgeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxBadgeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return NgxBadgeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-badge
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBadgeComponent, NgxBadgeModule };
